import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import documentList from "./documentList.vue";
import reviewHistoryList from "./reviewHistoryList.vue";
import operatingStatus from "./operatingStatus.vue";
import publishList from "./publishList.vue";
export default {
  name: "chatbotConfiguration",
  components: {
    documentList: documentList,
    reviewHistoryList: reviewHistoryList,
    operatingStatus: operatingStatus,
    publishList: publishList
  },
  data: function data() {
    return {
      activeIndex: 'documentList'
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};